import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";

const Availability = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-white">
      <SEOHead
        title="Check Area Availability | Clean Marketing"
        description="Check whether your town is available for exclusive window cleaning marketing with Clean Marketing, or join the waitlist."
        canonical="/availability"
      />
      {/* Top bar with close button */}
      <header className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-white shadow-sm">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-secondary hover:text-primary transition-colors"
        >
          <X className="h-5 w-5" />
          Back to Home
        </Link>
        <span className="text-sm font-medium text-slate-500 hidden sm:block">
          Clean Marketing - Area Availability Checker
        </span>
      </header>

      {/* Full-page iframe */}
      <iframe
        src="https://eclm.co.uk/check"
        className="w-full flex-1 border-0"
        title="Clean Marketing Area Availability Checker"
        loading="eager"
      />
    </div>
  );
};

export default Availability;
